import { FC, ReactNode } from 'react';
import Navigation from '@components/primitives/navigation/Navigation';
import { matchPath, useLocation } from 'react-router-dom';
import { PagePath } from '@routing/appUrls';
import StatusBar from '@components/features/statusBar/StatusBar';

interface Props {
    children: ReactNode;
}

const Layout: FC<Props> = ({ children }) => {
    const location = useLocation();
    const pagePathsWithoutNavigation: Array<string> = [PagePath.documentExternalView, PagePath.modalExternalView];
    const showNavigation = !pagePathsWithoutNavigation.some((pathPattern) => matchPath({ path: pathPattern, end: false }, location.pathname));

    return (
        <>
            {showNavigation && <Navigation />}
            <div className="layout">
                <StatusBar />
                {children}
            </div>
        </>
    );
};

export default Layout;
